import { SCREEN_NAME } from "@dineout-payment-success-ui/analytics/constants/Screen";
import { isEmpty } from "@swiggy-private/js-utils";

export interface ContactPickerAnalyticsPayload {
    orderId: string;
    screenName: string;
}

/**
 * Builds the JSON string for native bridge `CONTACT_PICKER.analyticsPayload`.
 * Returns undefined when orderId is missing so older web bundles can omit the field entirely.
 */
export const buildContactPickerAnalyticsPayload = ({
    orderId,
    screenName = SCREEN_NAME.PAYMENT_SUCCESS,
}: Partial<ContactPickerAnalyticsPayload>): string | undefined => {
    if (isEmpty(orderId)) {
        return undefined;
    }

    const payload: ContactPickerAnalyticsPayload = {
        orderId,
        screenName,
    };

    return JSON.stringify(payload);
};
